var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-page" }, [
    _c("div", { staticClass: "content-con" }, [
      _c("img", {
        staticClass: "img-con",
        attrs: { src: _vm.src, alt: _vm.code },
      }),
      _c(
        "div",
        { staticClass: "text-con" },
        [
          _c("h1", [_vm._v(_vm._s(_vm.code))]),
          _c("h5", [_vm._v(_vm._s(_vm.desc))]),
          _vm._t("btn_back"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }